import { defineStore } from 'pinia'

// 配置
export const useWxConfigStore = defineStore('wxconfig', {
	state: () => ({
		wxready: false,
    openUserId: '',
    corpId: '',
	}),
  persist: [
    {
      paths: ['openUserId', 'corpId'],
      storage: sessionStorage,
    }
  ],
})
